// extracted by mini-css-extract-plugin
export var contactSection = "styles-module--contactSection--o-Oo9";
export var contactInfo = "styles-module--contactInfo--14XUp";
export var addressName = "styles-module--addressName--iRi7B";
export var companyLogo = "styles-module--companyLogo--ivy1G";
export var companyName = "styles-module--companyName--Srhpc";
export var googleMap = "styles-module--googleMap--9ZK6V";
export var rodoLink = "styles-module--rodoLink--i+FzG";
export var contactInfoWrapper = "styles-module--contactInfoWrapper--uCT5F";